import { type RelatedArticles } from "@app/types/Opensearch";
import Date from "@elements/Typography/Date";
import Heading from "@elements/Typography/Heading";
import Link from "@elements/Typography/Link";
import { BH_BASE_URL } from "@helper/getEnvVariables";
import {
  removeLeadingSlash,
  removeTrailingSlash,
} from "@helper/removeTrailingLeadingSlash";
import { formatDate, formatTime } from "@helper/useDateFormat";
import { isArrayWithElements } from "@helper/utils";

export default function RelatedArticle({
  relatedArticles,
}: {
  relatedArticles: RelatedArticles;
}) {
  return (
    <div
      className="mb-6 lg:mb-8 border-b border-white-600 pb-3"
      data-testid="related-article-wrapper"
    >
      <Heading
        Element="h6"
        className="font-primary font-semibold text-sm leading-[150%] border-t-2 border-red-100 text-red-100 py-[10px] mb-3"
        testId={`related-article-header`}
      >
        Laporan berkaitan
      </Heading>
      <div className="flex flex-col gap-3 lg:gap-6">
        {isArrayWithElements(relatedArticles) &&
          relatedArticles.map(({ id, urlPath, title, dateCreated }, index) => {
            return (
              <div
                key={id}
                className="flex flex-col gap-[10px]"
                data-testid={`related-article-wrapper-${index}`}
              >
                {urlPath && (
                  <Link
                    testId={`related-article-title-${index}`}
                    destination={urlPath}
                    relativePath={false}
                    className="hover:underline leading-[120%] lg:leading-[130%] font-secondary text-[16px] lg:text-[22px] text-black-800 font-medium"
                  >
                    {title}
                  </Link>
                )}
                {dateCreated && (
                  <Date
                    date={formatDate(dateCreated)}
                    time={formatTime(dateCreated)}
                    variant={"or"}
                    className="text-[14px] font-semimedium leading-[150%] text-black-700"
                  />
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}

export function RelatedArticleMobile({
  relatedArticles,
}: {
  relatedArticles: RelatedArticles;
}) {
  return (
    <>
      <div className="paragraph paragraph--type--more-on-this-topic paragraph--view-mode--default">
        {"\n\n"}
        <div className="field field--name-field-related-articles field--type-entity-reference field--label-above">
          {"\n"}
          <div className="related-stories-title">Laporan berkaitan</div>
          {"\n"}
          <div className="related-stories-items">
            {"\n"}
            {isArrayWithElements(relatedArticles) &&
              relatedArticles.map(({ id, urlPath, title }, index) => {
                const fullUrl = `${removeTrailingSlash(BH_BASE_URL)}/${removeLeadingSlash(urlPath ?? "/")}`;
                return (
                  <div
                    key={id}
                    className="related-stories-item"
                    data-testid={`related-article-wrapper-${index}`}
                  >
                    <div className="related-stories-content">
                      <a
                        data-testid={`related-article-title-${index}`}
                        href={fullUrl}
                        hrefLang="en"
                      >
                        {title}
                      </a>
                      <a className="related-stories-arrow" href={fullUrl}>
                        &nbsp;
                      </a>
                    </div>
                    <div className="related-stories-border">{"&nbsp;"}</div>
                  </div>
                );
              })}
            {"\n"}
          </div>
          {"\n"}
        </div>
        {"\n\n"}
      </div>
      {"\n"}
    </>
  );
}
